import React from 'react';

const Pagination = ({ totalPages, currentPage, onPageChange, paginationId }) => {
  const handlePageClick = (page) => {
    onPageChange(page);
    // Scroll to products section
    const productsSection = document.getElementById('products');
    if (productsSection) {
      window.scrollTo({
        top: productsSection.offsetTop - 100,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="pagination-container mt-5 text-center">
      <nav aria-label="Page navigation">
        <ul className="pagination justify-content-center" id={paginationId}>
          {Array.from({ length: totalPages }, (_, index) => {
            const pageNumber = index + 1;
            return (
              <li 
                key={pageNumber} 
                className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(pageNumber)}
                  data-page={pageNumber}
                >
                  {pageNumber}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;